export type ProjectIntent =
  | "dog"
  | "deer"
  | "garden"
  | "restoration"
  | "installation_only"
  | "other";

export type PricingMode = "turnkey" | "installation_only";

export function estimatorPreselection(source?: string): ProjectIntent | null {
  if (!source) return null;
  const value = source.toLowerCase();
  if (value.includes("installation-only") || value.includes("install-only")) return "installation_only";
  if (value.includes("restoration")) return "restoration";
  if (value.includes("dog")) return "dog";
  if (value.includes("deer")) return "deer";
  if (value.includes("garden")) return "garden";
  return null;
}

export function pricingModeForIntent(intent: ProjectIntent | null): PricingMode {
  return intent === "installation_only" ? "installation_only" : "turnkey";
}

export function feetFromSteps(steps: number, feetPerStep: number) {
  if (!Number.isFinite(steps) || !Number.isFinite(feetPerStep)) return 0;
  return Math.round(Math.max(0, steps) * Math.max(0, feetPerStep));
}

export function shouldCalculatePrice(intent: ProjectIntent | null) {
  return intent !== "restoration";
}